<template>
	<form-field-wrap
		:field-props="fieldProps"
		:is-error="isError"
		:field-value="fieldValue"
		:is-switch="isSwitch"
		:with-label="withLabel"
	>
		<template>
			<label class="form__file-label" @click.prevent.stop="enter">
				<span v-html="title"></span>
			</label>
			<div>
				<input v-if="isMultiple"
				       class="form-control form-field-input hidden"
				       type="file"
				       ref="file"
				       autocomplete="off"
				       :disabled="isError"
				       :data-vv-as="fieldProps.TITLE"
				       :name="fieldProps.CODE"
				       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				       :multiple="isMultiple"
				       @change="onChangeFileUpload()">
				<input v-else
				       class="form-control form-field-input hidden"
				       type="file"
				       ref="file"
				       autocomplete="off"
				       v-validate="rules"
				       :data-vv-as="fieldProps.TITLE"
				       :name="fieldProps.CODE"
				       :value="filePaths[0]"
				       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
				       @input="onChangeFileUpload($event)">
			</div>
		</template>
		<template v-if="showTextFiles">
			<div class="form__file-list field_file_name" v-if="files.length > 0">
				<div class="form__file-nameWrap" v-for="(file, index) in files">
					<div class="form__file-name">
						<span class="form__file-name_start" v-html="editName(file.name, 0)"></span>
						<span class="form__file-name_end" v-html="editName(file.name, 1)"></span>
					</div>
					<a href="javascript:void(0);" class="form__file-icon form__delete js-form-delete-file"
					   v-if="files.length > 0" @click="fileDel(index)">
						<i class="icon icon--close"></i>
					</a>
				</div>
			</div>
		</template>
		<template slot="error-icon">
			<slot name="error-icon"></slot>
		</template>
	</form-field-wrap>
</template>
<script>
import {Vue} from "ui.vue";
import {formatFileSize} from '../plugins/vue-validate/locale/utils'

const TRUNCATE_NAME_LIMIT = 12;

/**
 * TODO multiple - не работает
 */
export default {
	name: "FormFieldFile",
	props: {
		value: {
			type: [File, FileList, Array, String, Number, null, undefined],
			required: false,
			default: () => {
				return []
			}
		},
		showTextFiles: {
			type: [String, Boolean, null, undefined],
			required: false,
			default: true
		},
		clearFileList: {
			type: [Boolean, null, undefined],
			required: false,
			default: false
		},
	},
	data: function () {
		return {
			files: [],
			filePaths: [],
			withLabel: false,
			error: false,
		}
	},
	watch: {
		value(newValue, oldValue) {
			this.inputValue = newValue;
		},
		error() {
			this.$emit('is-error', {
				error: this.error
			});
		},
		clearFileList() {
			this.files = [];
		}
	},
	computed: {
		localize() {
			return Vue.getFilteredPhrases("FIELD_FILE_");
		},
		rules() {
			let arRules = [];
			if (this.fieldProps.REQUIRED == "Y") {
				arRules.push('required');
			}
			if (this.fieldProps.hasOwnProperty("ADDITIONAL") && this.fieldProps.ADDITIONAL.hasOwnProperty("filetype") && this.fieldProps.ADDITIONAL.filetype) {
				arRules.push('ext:' + this.fieldProps.ADDITIONAL.filetype.replace(/[^a-z\.\,]+/g, ""));
			}
			if (this.fieldProps.hasOwnProperty("ADDITIONAL") && this.fieldProps.ADDITIONAL.hasOwnProperty("filesize") && this.fieldProps.ADDITIONAL.filesize) {
				arRules.push('size:' + this.fieldProps.ADDITIONAL.filesize);
			}

			arRules = arRules.concat(this.fieldProps.RULES);

			let stRules = arRules.join('|');
			return stRules;
		},
		isMultiple() {
			return this.fieldProps.hasOwnProperty('MULTIPLE') && this.fieldProps.MULTIPLE;
		},
		locPostfix() {
			return this.isMultiple ? "_MULTIPLE" : "";
		},
		title() {
			return this.fieldProps.PLACEHOLDER;
		},
		isError() {
			return this.error;
		},
	},
	methods: {
		onChangeFileUpload($event) {
			for (let file of this.$refs.file.files) {
				this.files.push(file);
			}

			this.checkValidFile();

			if (this.isMultiple) {
				this.$emit('input', this.files);
			} else {
				this.filePaths = [
					$event.target.value
				];

				this.$emit('input', this.files[0]);
			}
		},
		checkValidFile() {
			let errorFile = this.files.find(file => (file.size / 1024 > this.fieldProps.ADDITIONAL.filesize));

			if (!errorFile) return this.error = false;

			this.error = this.localize['FIELD_FILE_ERROR_size'].replace(/#field#/, errorFile.name).replace(/#size#/, formatFileSize(this.fieldProps.ADDITIONAL.filesize))
		},
		editName(fileName, index) {
			let arName = /(.*)(\.[a-zA-Z]+)$/g.exec(fileName);
			let notFile = (!Array.isArray(arName) || arName.length < 3);
			if (index == 1 && !notFile) {
				return arName[2];
			}

			let originName = notFile ? fileName : arName[1];
			if (originName.length < TRUNCATE_NAME_LIMIT) {
				return originName;
			}

			let firstSegment = originName.substring(0, TRUNCATE_NAME_LIMIT - 4);
			let lastSegment = originName.substring(originName.length - 1);

			return [firstSegment, lastSegment].join('...');
		},
		/**
		 * Удаление файлов
		 */
		allFilesDelete() {
			this.files = [];

			this.checkValidFile();
			if (this.isMultiple) {
				this.$emit('input', this.files);
			} else {
				this.$emit('input', this.files[0]);
			}
		},
		fileDel(key) {
			this.files = this.files.filter((item, index) => index != key);

			this.checkValidFile();

			if (this.isMultiple) {
				this.$emit('input', this.files);
			} else {
				this.$emit('input', this.files[0]);
			}
		},
		enter() {
			let id = this.fieldProps.ID ? this.fieldProps.ID : this.fieldProps.CODE;
			let input = document.getElementById(id);

			input.click();
		},
	},
}
</script>
